/**
 * Created by vaibhav on 31/3/18
 */
import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import Content, {HTMLContent} from '../components/Content';
import NavBar from '../components/NavBar';
import HeroCTA from '../components/HeroCTA';

export const ScholarsPageTemplate = ({title, content, contentComponent, heromain, herosub, herourl}) => {
    const PageContent = contentComponent || Content

    return (
        <div>
        <NavBar/>
            <section className="hero is-primary is-bold">
                <div className="hero-body">
                    <div className="container">
                        <div className="columns">
                            <div className="column is-10 is-offset-1">
                                <div className="section">
                                    <h1 className="title">
                                        {title}
                                    </h1>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="section section--gradient">
                <div className="container">
                    <div className="columns">
                        <div className="column is-10 is-offset-1">
                            <div className="section">
                                <PageContent className="content" content={content}/>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <HeroCTA             heromain={heromain}
                            herosub={herosub}
                            herourl={herourl}/>
        </div>
    )
};

ScholarsPageTemplate.propTypes = {
    title: PropTypes.string.isRequired,
    content: PropTypes.string,
    heromain: PropTypes.string,
    herosub: PropTypes.string,
    herourl: PropTypes.string,
    contentComponent: PropTypes.func,
};

const ScholarsPage = ({data}) => {
    const {markdownRemark: post} = data;

    return (
        <div className="scholars">
            <Helmet>
                <title>{post.frontmatter.meta_title}</title>
                <meta name="description" content={post.frontmatter.meta_description}/>
            </Helmet>
            <ScholarsPageTemplate
                contentComponent={HTMLContent}
                title={post.frontmatter.title}
                content={post.html}
                heromain={post.frontmatter.heromain}
                herosub={post.frontmatter.herosub}
                herourl={post.frontmatter.herourl}
            />
        </div>
    )
};

ScholarsPage.propTypes = {
    data: PropTypes.object,
};

export default ScholarsPage;

export const scholarsPageQuery = graphql`
  query ScholarsPage($id: String!) {
    markdownRemark(id: { eq: $id }) {
      html
      frontmatter {
        title
        meta_title
        meta_description
        heromain
        herosub
        herourl
      }
    }
  }
`;


// WEBPACK FOOTER //
// ./src/templates/scholars-page.js